import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { Product } from '../../../../classes/Product';
import { ModelService } from '../../../services/model.service';
import { GlobalService } from '../../../services/global.service';

@Component({
  selector: 'products-clone-popup',
  templateUrl: './products-clone-popup.component.html',
  styles: ['button[type=submit]{font-size: 1.25em;}'
  	,'.popup-body{position:relative;}.popup{display:flex;justify-content:center;}'
  	,'.sku-field{margin-bottom: 5px;}'
		,'.add-sku,.add-sku:hover,.remove-sku,.remove-sku:hover {margin-left: 5px;background-color: #8ac440;border: 1px solid #8ac440;-webkit-appearance: none;color: #fff;text-align: center;}'
		,'.remove-sku,.remove-sku:hover {background-color: #c44040;border: 1px solid #c44c40;}'
		,'.add-sku span,.remove-sku span {font-size: 2em;line-height: .5em;vertical-align: top;padding:6px 0;}']
})
export class ProductsClonePopupComponent implements OnInit {

	SKUs = [ '' ];
	addSKUButtonDisabled: boolean = true;

  constructor ( private model: ModelService, private global: GlobalService ) { }

  @Input( ) 
  popupVisible: boolean = false;

  @Input( ) 
  popupMinimized: boolean = false;

  @Input( ) 
  productID: number;

  @Output( ) 
  onClosePopup = new EventEmitter<any>( );

  @Output( ) 
  minimizePopup = new EventEmitter<any>( );

  @Output( ) 
  callback = new EventEmitter<any>( );

  ngOnInit ( ) { }

  checkDuplicatedSKUs ( ) {

    let _hasDuplicate: boolean = false;
    let _sortedSKUs: string[] = this.SKUs.slice( ).sort( );
    let i: number = 0;

    for ( i = 0; i < _sortedSKUs.length - 1; ++i ) {
      if ( _sortedSKUs[i] == _sortedSKUs[i+1] ) {
        _hasDuplicate = true;
      }
    }

    return _hasDuplicate;
  }

  cloneProduct ( ) { 

    if ( this.checkDuplicatedSKUs( ) ) {
  		this.callback.emit( { responseType: 'hasDuplicate', responseData: ''} );
      return;
    }

    this.model.cloneProduct( this.SKUs, this.productID, ( response ) => {
      if ( response.exists ) this.callback.emit( { responseType: 'exists', responseData: response.exists[0]} );
  		if ( response.answer && response.answer == 'success' ) {
    		this.SKUs = [ '' ];
        this.callback.emit( { responseType: 'success', responseData: '' } );
      }
    });
  }


  cancelCloneProduct ( ) { 
    this.SKUs = [ '' ];
		this.onClosePopup.emit( ); 
	}

  trackByIndex( index: number, obj: any ): any { return index; }


  addSKU ( ) {
    this.SKUs.push( '' );
    this.checkSKU( );
  }

  checkSKU ( ) {
    this.addSKUButtonDisabled = ( this.SKUs.indexOf( '' ) !== -1 ) ? true : false;
  }

  removeSKU ( _i: number ) {
    this.SKUs.splice( _i, 1 );
    this.checkSKU( );
  }

  minimizePopupHandle ( ) {
    this.minimizePopup.emit( );
  }


}


// WEBPACK FOOTER //
// /root/anvel/angular/app/components/products/products/products-clone-popup.component.ts